"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.datetime = void 0;
const _ = __importStar(require("lodash"));
const format_1 = __importDefault(require("date-fns/format"));
const parseISO_1 = __importDefault(require("date-fns/parseISO"));
function datetime(opts) {
    const fmt = opts.format || 'yyyy-MM-dd HH:mm';
    return function datetimeFormatter(row, cell, value, columnDef, data) {
        if (_.isString(value)) {
            value = (0, parseISO_1.default)(value);
        }
        return value ? (0, format_1.default)(value, fmt) : '';
    };
}
exports.datetime = datetime;
//# sourceMappingURL=datetime.js.map